// extracted by mini-css-extract-plugin
export default {"reservation_source":"reservationSource_reservation_source__LPc2E","text":"reservationSource_text__bjOsa"};